angular.module("vgresiduos").directive("topNavBar", function () {
	return {
		scope: true,
		controller: "topNavBarCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/components/topNavBar/topNavBar_template.html"
	};
});
